import * as R from 'ramda';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// utilities
import { sendRequest } from '../../utilities/http';
import endpointsMap from '../../utilities/endpoints';
//////////////////////////////////////////////////

const getTelBranchGuid = (props) => R.or(
  R.or(props.branchGuid, R.path([GC.FIELD_TEL, GC.FIELD_BRANCH_GUID], props)),
  R.path([GC.FIELD_TEL, GC.FIELD_BRANCH, GC.FIELD_GUID], props),
);

const getDriverCompensationsReqBody = (driverGuid, props) => {
  const { values, telGuid, loadData, telEvents, isFromOrder, isFromPlanner } = props;

  const { serviceType, customerTotal, transportationMode } = values;

  const branchGuid = getTelBranchGuid(props);

  if (G.isAllTrue(
    G.isTrue(isFromPlanner),
    G.isNotNilAndNotEmpty(driverGuid),
    G.isNotNilAndNotEmpty(branchGuid),
    G.isNotNilAndNotEmpty(telEvents),
  )) {
    return {
      telGuid,
      driverGuid,
      serviceType,
      customerTotal,
      loadGuid: telGuid,
      transportationMode,
      loadData: {
        events: telEvents,
      },
      [GC.FIELD_BRANCH_GUID]: branchGuid,
    };
  }

  if (G.isAllTrue(
    G.isTrue(isFromOrder),
    G.isNotNilAndNotEmpty(driverGuid),
    G.isNotNilAndNotEmpty(branchGuid),
    G.isNotNilAndNotEmpty(loadData),
  )) {
    return {
      loadData,
      driverGuid,
      serviceType,
      customerTotal,
      transportationMode,
      [GC.FIELD_BRANCH_GUID]: branchGuid,
    };
  }

  if (G.isAllTrue(
    G.isNotNilAndNotEmpty(driverGuid),
    G.isNotNilAndNotEmpty(branchGuid),
    G.isNotNilAndNotEmpty(telGuid),
  )) {
    return {
      telGuid,
      driverGuid,
      serviceType,
      customerTotal,
      loadGuid: telGuid,
      transportationMode,
      [GC.FIELD_BRANCH_GUID]: branchGuid,
    };
  }
};

const getTeamDriverCompensations = async (driverGuid, props) => {
  const { openLoader, closeLoader, requestDriverRateData = sendRequest } = props;

  try {
    G.callFunction(openLoader);

    const reqBody = getDriverCompensationsReqBody(driverGuid, props);

    const res = await requestDriverRateData(
      'post',
      endpointsMap.driverCompensations,
      { data: reqBody },
    );

    const { data, status } = res;

    if (G.isResponseFail(status)) {
      G.callFunction(closeLoader);
      G.handleFailResponseSimple(res, false, 'getTeamDriverCompensations');

      return null;
    }

    G.callFunction(closeLoader);

    return data;
  } catch (error) {
    G.callFunction(closeLoader);
    G.handleException('error', 'getTeamDriverCompensations exception');
  }
};

export {
  getTeamDriverCompensations,
  getDriverCompensationsReqBody,
};
